import React, { useState } from 'react';
import { FaSave, FaTimes, FaCheckCircle, FaFilePdf } from 'react-icons/fa';

const FloridaChecklistForm = ({ initialData, onSave, onCancel, isSubmitting }) => {
  const [formData, setFormData] = useState(initialData || {
    businessName: '',
    einNumber: '',
    principalAddress: '',
    mailingAddress: '',
    registeredAgent: '',
    registeredAgentAddress: '',
    director1Name: '',
    director1Address: '',
    director2Name: '',
    director2Address: '',
    director3Name: '',
    director3Address: '',
    emailAddress: '',
    certifyName: '',
    certifyTitle: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData, true);
  };

  return (
    <div className="bg-white dark:bg-dark-800 rounded-2xl shadow-xl overflow-hidden border border-gray-100 dark:border-dark-700">
      <div className="p-6 border-b border-gray-100 dark:border-dark-700 flex justify-between items-center bg-gradient-to-r from-indigo-500 to-purple-600">
        <h2 className="text-xl font-bold text-white flex items-center gap-2">
          <FaCheckCircle /> Florida Checklist
        </h2>
        <button onClick={onCancel} className="text-white/80 hover:text-white transition-colors">
          <FaTimes className="w-6 h-6" />
        </button>
      </div>

      <form onSubmit={handleSubmit} className="p-6 space-y-8">
        {/* Section A: Basic Business Details */}
        <div>
          <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
            <span className="w-8 h-8 rounded-lg bg-indigo-100 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-400 flex items-center justify-center text-sm font-bold">A</span>
            Basic Business Details
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-1">
              <label className="text-sm font-semibold text-gray-700 dark:text-gray-300">Business Name</label>
              <input
                type="text"
                name="businessName"
                value={formData.businessName}
                onChange={handleChange}
                className="w-full px-4 py-2.5 rounded-xl border border-gray-200 dark:border-dark-600 bg-gray-50 dark:bg-dark-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-indigo-500 transition-all outline-none"
                placeholder="Enter Business Name"
                required
              />
            </div>
            <div className="space-y-1">
              <label className="text-sm font-semibold text-gray-700 dark:text-gray-300">EIN Number</label>
              <input
                type="text"
                name="einNumber"
                value={formData.einNumber}
                onChange={handleChange}
                className="w-full px-4 py-2.5 rounded-xl border border-gray-200 dark:border-dark-600 bg-gray-50 dark:bg-dark-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-indigo-500 transition-all outline-none"
                placeholder="Enter EIN Number"
                required
              />
            </div>
            <div className="space-y-1 md:col-span-2">
              <label className="text-sm font-semibold text-gray-700 dark:text-gray-300">Principal Address</label>
              <textarea
                name="principalAddress"
                value={formData.principalAddress}
                onChange={handleChange}
                rows="2"
                className="w-full px-4 py-2.5 rounded-xl border border-gray-200 dark:border-dark-600 bg-gray-50 dark:bg-dark-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-indigo-500 transition-all outline-none"
                placeholder="Enter Principal Address"
                required
              />
            </div>
            <div className="space-y-1 md:col-span-2">
              <label className="text-sm font-semibold text-gray-700 dark:text-gray-300">Mailing Address</label>
              <textarea
                name="mailingAddress"
                value={formData.mailingAddress}
                onChange={handleChange}
                rows="2"
                className="w-full px-4 py-2.5 rounded-xl border border-gray-200 dark:border-dark-600 bg-gray-50 dark:bg-dark-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-indigo-500 transition-all outline-none"
                placeholder="Enter Mailing Address"
                required
              />
            </div>
            <div className="space-y-1">
              <label className="text-sm font-semibold text-gray-700 dark:text-gray-300">Registered Agent</label>
              <input
                type="text"
                name="registeredAgent"
                value={formData.registeredAgent}
                onChange={handleChange}
                className="w-full px-4 py-2.5 rounded-xl border border-gray-200 dark:border-dark-600 bg-gray-50 dark:bg-dark-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-indigo-500 transition-all outline-none"
                placeholder="Enter Registered Agent"
                required
              />
            </div>
            <div className="space-y-1">
              <label className="text-sm font-semibold text-gray-700 dark:text-gray-300">Registered Agent Address</label>
              <input
                type="text"
                name="registeredAgentAddress"
                value={formData.registeredAgentAddress}
                onChange={handleChange}
                className="w-full px-4 py-2.5 rounded-xl border border-gray-200 dark:border-dark-600 bg-gray-50 dark:bg-dark-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-indigo-500 transition-all outline-none"
                placeholder="Enter Registered Agent Address"
                required
              />
            </div>
          </div>
        </div>

        {/* Section B: Director Detail */}
        <div>
          <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
            <span className="w-8 h-8 rounded-lg bg-indigo-100 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-400 flex items-center justify-center text-sm font-bold">B</span>
            Director Detail
          </h3>
          <div className="space-y-6">
            {/* Director 1 */}
            <div className="p-4 rounded-2xl border border-gray-100 dark:border-dark-700 bg-gray-50/50 dark:bg-dark-700/30 grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-1">
                <label className="text-xs font-bold uppercase tracking-wider text-gray-500">Director 1 Name</label>
                <input
                  type="text"
                  name="director1Name"
                  value={formData.director1Name}
                  onChange={handleChange}
                  className="w-full px-4 py-2 rounded-xl border border-gray-200 dark:border-dark-600 bg-white dark:bg-dark-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-indigo-500 outline-none"
                  placeholder="Full Name"
                />
              </div>
              <div className="space-y-1">
                <label className="text-xs font-bold uppercase tracking-wider text-gray-500">Director 1 Address</label>
                <input
                  type="text"
                  name="director1Address"
                  value={formData.director1Address}
                  onChange={handleChange}
                  className="w-full px-4 py-2 rounded-xl border border-gray-200 dark:border-dark-600 bg-white dark:bg-dark-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-indigo-500 outline-none"
                  placeholder="Address"
                />
              </div>
            </div>

            {/* Director 2 */}
            <div className="p-4 rounded-2xl border border-gray-100 dark:border-dark-700 bg-gray-50/50 dark:bg-dark-700/30 grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-1">
                <label className="text-xs font-bold uppercase tracking-wider text-gray-500">Director 2 Name</label>
                <input
                  type="text"
                  name="director2Name"
                  value={formData.director2Name}
                  onChange={handleChange}
                  className="w-full px-4 py-2 rounded-xl border border-gray-200 dark:border-dark-600 bg-white dark:bg-dark-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-indigo-500 outline-none"
                  placeholder="Full Name"
                />
              </div>
              <div className="space-y-1">
                <label className="text-xs font-bold uppercase tracking-wider text-gray-500">Director 2 Address</label>
                <input
                  type="text"
                  name="director2Address"
                  value={formData.director2Address}
                  onChange={handleChange}
                  className="w-full px-4 py-2 rounded-xl border border-gray-200 dark:border-dark-600 bg-white dark:bg-dark-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-indigo-500 outline-none"
                  placeholder="Address"
                />
              </div>
            </div>

            {/* Director 3 */}
            <div className="p-4 rounded-2xl border border-gray-100 dark:border-dark-700 bg-gray-50/50 dark:bg-dark-700/30 grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-1">
                <label className="text-xs font-bold uppercase tracking-wider text-gray-500">Director 3 Name</label>
                <input
                  type="text"
                  name="director3Name"
                  value={formData.director3Name}
                  onChange={handleChange}
                  className="w-full px-4 py-2 rounded-xl border border-gray-200 dark:border-dark-600 bg-white dark:bg-dark-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-indigo-500 outline-none"
                  placeholder="Full Name"
                />
              </div>
              <div className="space-y-1">
                <label className="text-xs font-bold uppercase tracking-wider text-gray-500">Director 3 Address</label>
                <input
                  type="text"
                  name="director3Address"
                  value={formData.director3Address}
                  onChange={handleChange}
                  className="w-full px-4 py-2 rounded-xl border border-gray-200 dark:border-dark-600 bg-white dark:bg-dark-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-indigo-500 outline-none"
                  placeholder="Address"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Email and Certification */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-4 border-t border-gray-100 dark:border-dark-700">
          <div className="space-y-1">
            <label className="text-sm font-semibold text-gray-700 dark:text-gray-300">Email Address</label>
            <input
              type="email"
              name="emailAddress"
              value={formData.emailAddress}
              onChange={handleChange}
              className="w-full px-4 py-2.5 rounded-xl border border-gray-200 dark:border-dark-600 bg-gray-50 dark:bg-dark-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-indigo-500 outline-none"
              placeholder="Email"
              required
            />
          </div>
          <div className="space-y-1">
            <label className="text-sm font-semibold text-gray-700 dark:text-gray-300">Certify Name</label>
            <input
              type="text"
              name="certifyName"
              value={formData.certifyName}
              onChange={handleChange}
              className="w-full px-4 py-2.5 rounded-xl border border-gray-200 dark:border-dark-600 bg-gray-50 dark:bg-dark-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-indigo-500 outline-none"
              placeholder="Name"
              required
            />
          </div>
          <div className="space-y-1">
            <label className="text-sm font-semibold text-gray-700 dark:text-gray-300">Title</label>
            <input
              type="text"
              name="certifyTitle"
              value={formData.certifyTitle}
              onChange={handleChange}
              className="w-full px-4 py-2.5 rounded-xl border border-gray-200 dark:border-dark-600 bg-gray-50 dark:bg-dark-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-indigo-500 outline-none"
              placeholder="Title"
              required
            />
          </div>
        </div>

        <div className="flex justify-end gap-4 pt-6">
          <button
            type="button"
            onClick={onCancel}
            className="px-6 py-2.5 rounded-xl font-semibold text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-dark-700 transition-all"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => onSave(formData, false)}
            disabled={isSubmitting}
            className="px-6 py-2.5 bg-gray-100 dark:bg-dark-700 text-gray-700 dark:text-gray-300 font-bold rounded-xl hover:bg-gray-200 dark:hover:bg-dark-600 transition-all flex items-center gap-2 disabled:opacity-50"
          >
            <FaSave /> Save as Draft
          </button>
          <button
            type="submit"
            disabled={isSubmitting}
            className="px-8 py-2.5 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-bold rounded-xl shadow-lg shadow-indigo-500/25 hover:shadow-xl hover:shadow-indigo-500/40 transition-all flex items-center gap-2 disabled:opacity-50"
          >
            {isSubmitting ? (
              <><span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span> Submitting...</>
            ) : (
              <><FaFilePdf /> Submit Checklist</>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default FloridaChecklistForm;
